import styled from 'styled-components'

const Box = styled.div`
  padding: 27px 42px 27px 40px;
`

export const s = { Box }
